export const WhyWeSpecialize = () => {
  const reasons = [
    {
      icon: 'ri-funds-line',
      title: 'Strong Capital Access',
      description: 'We have the financial resources and institutional relationships to close on larger mid-rise properties quickly and confidently.'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team',
      description: 'Our team has decades of combined experience managing and acquiring mid-rise apartment buildings across multiple markets.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Market Expertise',
      description: 'We understand urban market dynamics, zoning regulations, and the unique challenges of mid-rise property ownership.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Operational Capability',
      description: 'We can handle properties with deferred maintenance, management issues, or complex operational challenges.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Fast Closings',
      description: 'Our streamlined process and ready capital allow us to close in 30-45 days, much faster than traditional sales.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Fair Valuations',
      description: 'We provide competitive offers based on current market conditions, property performance, and future potential.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Why We Specialize in Mid-Rise Properties
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mid-rise apartment buildings require specialized knowledge, significant capital, and operational expertise. We've built our business specifically to serve owners of these properties.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 text-white rounded-xl mb-6">
                <i className={`${reason.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">Our Mid-Rise Acquisition Focus</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                We actively seek mid-rise apartment buildings in urban and suburban markets. Whether your property is fully stabilized or facing challenges, we're interested in discussing an acquisition.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Condition:</strong> From Class A to value-add opportunities</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Occupancy:</strong> Fully leased or partially vacant</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Market:</strong> Primary, secondary, and emerging markets</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong>Any Situation:</strong> Estate sales, partnerships, financial distress</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/20629b9fe64a9c04dd4d36d78b473e4c.jpg"
                  alt="Mid-Rise Acquisition Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};